import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { ADDITIONAL_TEXT_PATH, TWITTER_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";

const INSTAGRAM_SPELL_NAME = "instagram";

const FillOrigamiStepProps = {
  previous: TWITTER_PATH,
  next: ADDITIONAL_TEXT_PATH,
  question: "What's your <%= target %> profile URL",
  target: "Instagram",
  spellName: INSTAGRAM_SPELL_NAME,
  placeholder: "username",
  required: false,
  prependValue: "https://instagram.com/",
};

export const InstagramStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(InstagramStep);
